import { Component } from '@angular/core';

@Component({
  selector: 'app-mobile-phone-icon',
  templateUrl: './mobile-phone-icon.component.html',
  styleUrl: './mobile-phone-icon.component.scss',
})
export class MobilePhoneIconComponent {}
